import React, { useState, useEffect } from 'react';

const TypingEffect = ({ strings, typeSpeed = 100, backSpeed = 50, delay = 1500 }) => {
  const [currentText, setCurrentText] = useState('');
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      const currentString = strings[currentIndex];
      
      if (!isDeleting) {
        // Typing
        setCurrentText(currentString.substring(0, currentText.length + 1));
        
        if (currentText === currentString) {
          // Finished typing
          setTimeout(() => setIsDeleting(true), delay);
        }
      } else {
        // Deleting
        setCurrentText(currentString.substring(0, currentText.length - 1));
        
        if (currentText === '') {
          // Finished deleting
          setIsDeleting(false);
          setCurrentIndex((prev) => (prev + 1) % strings.length);
        }
      }
    }, isDeleting ? backSpeed : typeSpeed);

    return () => clearTimeout(timer);
  }, [currentText, currentIndex, isDeleting, strings, typeSpeed, backSpeed, delay]);

  return <span className="typed-text">{currentText}</span>;
};

export default TypingEffect;